import i18n from 'i18next'
import detector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

export const i18nextCookieName = 'i18next'

const resources = {
  fi: {
    translation: {
      download: 'Tallenna',
      frontPage: 'Etusivu',
      headerTitle: 'EU:n alue- ja rakennepolitiikan hanketietopalvelu ohjelmakaudelle 2021—2027',
      loadingCapacity: 'Ladataan kapasiteettia',
      loadingFailed: 'Raporttien lataaminen epäonnistui. Yritä hetken päästä uudestaan.',
      loadingReport: 'Ladataan raporttia',
      project: 'Hanke',
      projectInfoDescription:'Voit hakea hanketietoja joko eri hakuehtoja valitsemalla tai etenemällä sivun alaosassa olevien rahasto- ja erityistavoitekohtaisten linkkien avulla. Haun mukaiset hankkeet listautuvat taulukkoon, jonka kautta voi avata hankekohtaisen kuvauksen.',
      projectInfoService: 'Hanketietojen haku',
      startingCapacity: 'Käynnistetään kapasiteettia',
      tiepaResultsLong: 'Tietoja ohjelman tuloksista',
      updatedAt: 'Tiedot päivitetty EURA 2021 -järjestelmästä {{date}}.',
    },
  },
  sv: {
    translation: {
      download: 'Ladda ner',
      frontPage: 'Framsida',
      headerTitle: 'Projektinformationstjänsten för EU:s regional- och strukturpolitiska fonder för programperioden 2021—2027',
      loadingCapacity: 'Laddar kapacitet',
      loadingFailed: 'Det gick inte att läsa in rapporter',
      loadingReport: 'Laddar rapporten',
      project: 'Projekt',
      projectInfoDescription:'Du kan söka projektuppgifter antingen genom att välja olika sökvillkor eller genom att gå vidare med länkarna för fonder och specifika mål nere på sidan. Projekten i ansökan visas i en tabell, genom vilken du kan öppna en projektspecifik beskrivning.',
      projectInfoService: 'Projektinformationstjänsten',
      startingCapacity: 'Kapacitet lansering',
      tiepaResultsLong: 'Information om programmets resultat',
      updatedAt: 'Information uppdaterad från EURA 2021-systemet {{date}}.',
    },
  },
  en: {
    translation: {
      download: 'Download',
      frontPage: 'Front page',
      headerTitle: "Project information service for European Union's region and structure policy for program period 2021—2027",
      loadingCapacity: 'Loading capacity',
      loadingFailed: 'Loading reports failed',
      loadingReport: 'Loading report',
      project: 'Project',
      projectInfoDescription:'You can search for project information either by selecting different search criteria or by going through the fund and specific objective links at the bottom of the page. The projects found in the search are listed in a table in which the user can open a description of each project.',
      projectInfoService: 'Project information service',
      startingCapacity: 'Starting capacity',
      tiepaResultsLong: 'Information on the results of the programme',
      updatedAt: 'Updated from EURA 2021 system on {{date}}.',
    },
  },
}

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    supportedLngs: ['fi', 'sv', 'en'],
    returnNull: false, // Ei palauteta tyhjää arvoa; 'en' -> 'fi' -fallback ei toimi ilman tätä.
    detection: {
      order: ['querystring', 'cookie', 'navigator'],
      lookupCookie: i18nextCookieName,
      caches: ['cookie'],
      cookieMinutes: 10 * 365 * 24 * 60, // 10 vuotta minuutteina
      cookieDomain:
        typeof window !== 'undefined' ? window.location.hostname.split('.').slice(-2).join('.').replace(/^\./, '') : 'eura2021.fi',
      cookieOptions: {
        path: '/',
        sameSite: 'Lax' as any,
      },
    },
    resources,
    fallbackLng: 'fi',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
